export default __webpack_public_path__ + "static/media/germany.49e437d5.MOV";